import React from 'react';
import { compose, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import CancelButton from '../atoms/CancelButton';
import SubmitButton from '../atoms/SubmitButton';

const styles = {
  paperWidthSm: {
    maxWidth: 325
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 14,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: 10,
    fontSize: 14
  },
  detailTtl: {
    fontSize: 24,
    fontWeight: 700,
    color: '#333333',
    padding: '15px 10px 10px 0'
  },
  footerButton: {
    justifyContent: 'flex-start',
    marginBottom: 20,
    marginLeft: 20
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(setPropTypes(propTypes));

const Main = enhance(
  ({
    classes,
    openConfirm,
    updateOpenConfirm,
    okAction,
    settings,
    listDay,
    isSmall,
    hasSetting,
    shopHolidayList
  }) => {
    const cancelAction = () => updateOpenConfirm(false);
    return (
      <Dialog
        open={openConfirm}
        onClose={() => {
          updateOpenConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classes.paperWidthSm
        }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {!hasSetting ? (
              <Typography variant="h6" className={classes.detailTtl}>
                利用制限の設定 確認
              </Typography>
            ) : (
              <Typography variant="h6" className={classes.detailTtl}>
                利用制限の設定 編集 確認
              </Typography>
            )}
            <Paper className={classes.rootPaper}>
              <Table className={classes.detailTable}>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      利用曜日
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {listDay !== undefined &&
                        Object.keys(listDay).length !== 0 &&
                        listDay.map(day => {
                          let days = '';
                          if (
                            settings.dayUseWeek &&
                            settings.dayUseWeek.length > 0 &&
                            settings.dayUseWeek.includes(day.value)
                          ) {
                            days += `${day.label}${
                              day.value ===
                                settings.dayUseWeek.sort()[
                                  settings.dayUseWeek.length - 1
                                ] &&
                              settings &&
                              settings.validHoliday === 0
                                ? ''
                                : ', '
                            }`;
                          }
                          return days;
                        })}
                      {settings && settings.validHoliday
                        ? '祝日利用可'
                        : '祝日利用不可'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      不定休
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {shopHolidayList
                        .filter(value => value !== '')
                        .map((day, index) => {
                          return (
                            <div>
                              {`${moment(day).format('YYYY年MM月DD日')}${
                                shopHolidayList.length - 1 === index ? '' : ','
                              }`}
                            </div>
                          );
                        })}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      利用時間
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {`${
                        settings && settings.useStartTime !== null
                          ? settings.useStartTime
                          : ''
                      }~${
                        settings && settings.useEndTime !== null
                          ? settings.useEndTime
                          : ''
                      }`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      利用回数
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {settings && settings.limitNumUsedDay !== null
                        ? settings.limitNumUsedDay
                        : ''}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.footerButton}>
          <CancelButton
            onClickAction={cancelAction}
            color="default"
            btnText="戻る"
          />
          <SubmitButton onClickAction={okAction} btnText="設定" />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
